import { FormLayout, Modal, TextField, Text, ChoiceList } from '@shopify/polaris';
import { Choice } from '@shopify/polaris/build/ts/src/components/Choice';
import { lengthLessThan, lengthMoreThan, notEmptyString, useField, useForm } from '@shopify/react-form';
import { useNotification } from 'context/NotificationContext';
import helpers from 'helpers/index';
import { useMutateRemoveDebitClearing } from 'queries/transactions.query';
import { useCallback, useEffect, useState } from 'react';

export default function DebitClearModal({ show, transactionsID, onClose }: { show: boolean; transactionsID: any[]; onClose: () => void }) {
  const { data, mutateAsync: debitClearingFn, isPending } = useMutateRemoveDebitClearing();

  const { addNotification } = useNotification();
  const useFields = {
    debt_clear_note: useField<string>({
      value: '',
      validates: [
        notEmptyString('Trường này không được để trống.'),
        lengthMoreThan(10, 'Không đủ chi tiết cho giao dịch.'),
        lengthLessThan(500, 'Bạn điền quá dài!'),
      ],
    }),

    transaction_id: useField<any[]>({
      value: transactionsID,
      validates: [],
    }),
    payment_method: useField<string>({
      value: 'CASH',
      validates: [],
    }),
  };

  const {
    fields,
    submit,
    reset: resetForm,
    makeClean,
  } = useForm({
    fields: useFields,
    async onSubmit(form) {
      try {
        await debitClearingFn({
          debt_clear_note: fields.debt_clear_note.value,
          payment_method: fields.payment_method.value,
          transaction_id: fields.transaction_id.value,
        });
        closeBulkDebtModal();
        addNotification('info', 'Gạt nợ thành công!');
      } catch (e) {}
      return { status: 'success' };
    },
  });

  useEffect(() => {
    resetForm();
    makeClean();
  }, []);

  const closeBulkDebtModal = useCallback(() => {
    helpers.cleanEntity(useFields);
    onClose();
  }, []);

  return (
    <>
      <Modal
        open={show}
        onClose={closeBulkDebtModal}
        title="Gạt nợ hàng loạt"
        primaryAction={{
          content: 'Xác nhận gạt nợ',
          disabled: isPending,
          loading: isPending,
          onAction: submit,
        }}
        secondaryActions={[{ content: 'Hủy', onAction: closeBulkDebtModal }]}
      >
        <Modal.Section>
          <FormLayout>
            <Text as="p">Các giao dịch công nợ đã chọn: {transactionsID.join(', ') || '--'}</Text>
            <TextField
              label="Thông tin gạt nợ"
              multiline={4}
              autoComplete="off"
              requiredIndicator
              placeholder="Nhập ghi chú hoặc thông tin gạt nợ"
              helpText={'Bút toán sẽ được lưu lại và cập nhật vào tất cả các record bạn đang chọn, vì thế, càng chi tiết càng tốt.'}
              {...fields.debt_clear_note}
            />

            <ChoiceList
              title={'Phương pháp gạt nợ'}
              selected={[fields.payment_method.value]}
              choices={[
                {
                  label: 'Tiền mặt',
                  value: 'CASH',
                },
                {
                  label: 'Chuyển khoản',
                  value: 'BANK',
                },
              ]}
              onChange={(v) => fields.payment_method.onChange(v.pop())}
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
    </>
  );
}

